import React, { useState } from "react"
import Icon from "../../common/icon/icon.component"
import ButtonWrapper from "../../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import { isError } from "../../state/helpers/Error"
import IntlProps from "../../state/helpers/IntlProps"
import Shortcut from "../../state/shortcut/Shortcut"
import ShortcutService from "../../state/shortcut/ShortcutService"
import ShortcutsSettingsModal from "./ShortcutsSettingsModal"
import { injectIntl } from "react-intl"
import NewOrderModal from "../../order/NewOrderModal"
import NewInvoiceModal from "../../invoice/newmodal.component"
import { getIconValue, SHORTCUT_ACTION_TYPE } from "../../state/shortcut/ShortcutAction"
import { actions } from "./helpers.jsx"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { RouteComponentProps, withRouter } from "react-router"

const LINK = "link"
const MODAL = "modal"

const getRedirectInfo = (shortcut: Shortcut) => {
    let onClickRedirectType
    let redirectLink
    switch (shortcut.getActionName()) {
    case SHORTCUT_ACTION_TYPE.CREATE_CONTACT:
        onClickRedirectType = LINK
        redirectLink = "/contacts/new"
        break
    case SHORTCUT_ACTION_TYPE.CREATE_QUOTE:
        onClickRedirectType = LINK
        redirectLink = "/quotes/new"
        break
    case SHORTCUT_ACTION_TYPE.CREATE_INVOICE:
        onClickRedirectType = MODAL
        redirectLink = "/invoices/:id/edit"
        break
    case SHORTCUT_ACTION_TYPE.CREATE_ORDER:
        onClickRedirectType = MODAL
        redirectLink = "/orders/:id/edit"
        break
    case SHORTCUT_ACTION_TYPE.CREATE_SUBSCRIPTION:
        onClickRedirectType = MODAL
        redirectLink = "/invoices/:id/edit"
        break
    case SHORTCUT_ACTION_TYPE.CREATE_APPOINTMENT:
        onClickRedirectType = LINK
        redirectLink = "/calendar-events/new"
        break
    case SHORTCUT_ACTION_TYPE.CLONE_INVOICE:
        onClickRedirectType = MODAL
        redirectLink = "/invoices/:id/edit"
        break
    case SHORTCUT_ACTION_TYPE.CLONE_QUOTE:
        onClickRedirectType = LINK
        redirectLink = "/quotes/create-from/:projectId/:id"
        break
    }
    return {onClickRedirectType, redirectLink}
}

interface Props {
    isEditable: boolean,
    shortcut: Shortcut,
    locationId: string,
    handleShortcutsList: (shortcutType: string, updatedShortcut: Shortcut, handleType: string) => void,
}

const ShortcutActionComponent: React.FC<Props & IntlProps & RouteComponentProps> = (props) => {

    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false)
    const [errorMsg, setErrorMsg] = useState<string>("")
    const [isActionModalOpen, setActionModalOpen] = useState(false)
    const {onClickRedirectType, redirectLink} = getRedirectInfo(props.shortcut)

    const openShortcutsSettingsModal = () => {
        setIsSettingsModalOpen(true)
    }

    const closeShortcutsSettingsModal = () => {
        setIsSettingsModalOpen(false)
    }

    const deleteShortcut = () => {
        ShortcutService.deleteShortcut(props.shortcut.getId()).then((r) => {
            if (!isError(r)) {
                props.handleShortcutsList(props.shortcut.getShortcutType(), props.shortcut, "delete")
            } else {
                setErrorMsg(r.message)
            }
        })
    }

    const openModal = () => {
        setActionModalOpen(true)
    }

    const closeModal = (id?: string) => {
        if (id && redirectLink) {
            location.href = redirectLink.replace(":id", id)
        }
        setActionModalOpen(false)
    }

    const onClick = () => {
        if (props.isEditable) {
            return
        }
        if (onClickRedirectType === LINK) {
            props.history.push(getRedirectLink())
        } else {
            openModal()
        }
    }

    const getRedirectLink = () => {
        return redirectLink.replace(":id", props.shortcut.getCloneId()).replace(":projectId", props.shortcut.getProjectId())
    }

    const getActionModal = () => {
        switch (props.shortcut.getActionName()) {
        case SHORTCUT_ACTION_TYPE.CREATE_INVOICE:
            return <NewInvoiceModal onClose={closeModal}/>
        case SHORTCUT_ACTION_TYPE.CREATE_ORDER:
            return <NewOrderModal onClose={closeModal}/>
        case SHORTCUT_ACTION_TYPE.CREATE_SUBSCRIPTION:
            return <NewInvoiceModal onClose={closeModal} recurring={true}/>
        case SHORTCUT_ACTION_TYPE.CLONE_INVOICE:
            return <NewInvoiceModal onClose={closeModal} fromInvoiceId={props.shortcut.getCloneId()}
                fromProjectId={props.shortcut.getProjectId()}/>
        default:
            return <></>
        }
    }

    const getProtectionRule = () => {
        const action = actions.find(a => a.actionName == props.shortcut.getActionName())
        if (!action || !action.feature) {
            return true
        }
        return AppContext.accountFeatureIsEnabled(action.feature)
    }

    return (
        <>
            <div className={props.isEditable ? "col-sm-12" : "py-1"}>
                <div className="text-danger">{errorMsg}</div>
                {/* Action button */}
                <ButtonWrapper
                    onClick={onClick}
                    className={`btn btn-lg btn-primary bg-${props.shortcut.getColor()} border-0 dashboard-shortcut-action-button`}
                    protectedClassName={`btn btn-lg btn-primary bg-${
                        props.shortcut.getColor()
                    } border-0 dashboard-shortcut-action-button`}
                    redirectToAccount={true}
                    premium={false}
                    protectionRule={getProtectionRule() || props.isEditable}
                >
                    {props.isEditable &&
                        // Edit buttons
                        <div className={"d-flex justify-content-center mb-2 "}>
                            <button className={"mr-2 btn-sm text-white bg-transparent shortcut-action-edits-buttons"}
                                onClick={openShortcutsSettingsModal}>
                                <Icon value={"edit"} className={"pl-0"}/>
                            </button>
                            <button className={"mr-2 btn-sm text-white bg-transparent shortcut-action-edits-buttons"}
                                onClick={deleteShortcut}>
                                <Icon value={"trash"} className={"pl-0"}/>
                            </button>
                        </div>
                    }
                    <Icon value={getIconValue(props.shortcut.getActionName())} className={"mr-2"}/>
                    {props.shortcut.getName()}
                </ButtonWrapper>
                {isSettingsModalOpen &&
                    <ShortcutsSettingsModal
                        shortcut={props.shortcut}
                        onClose={closeShortcutsSettingsModal}
                        handleShortcutsList={props.handleShortcutsList}
                    />
                }
            </div>
            {isActionModalOpen && getActionModal()}
        </>
    )
}
export default injectIntl(withRouter(ShortcutActionComponent))


// WEBPACK FOOTER //
// ./src/shortcuts/components/ShortcutActionComponent.tsx